import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const referralSettingsSlice = createSlice({
    name: "referralSettings",
    initialState: {
        success: false,
        fail: false,
        settings: null,
        responseData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetReferralSettingsSuccess: (state, action) => {
            state.settings = action.payload.data;
        },
        doGetReferralSettingsFail: (state) => {
            state.settings = null;
        },
        doUpdateReferralSettingsSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
            state.responseData = action.payload;
        },
        doUpdateReferralSettingsFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        resetReferralSettingsStateSuccess: (state) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

export const doGetReferralSettings = () => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/referral-settings`);
        dispatch(doGetReferralSettingsSuccess(response.data));
    } catch (error) {
        dispatch(doGetReferralSettingsFail(error.response));
    }
};

export const doUpdateReferralSettings = (param) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/admin/referral-settings`, param);
        dispatch(doUpdateReferralSettingsSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateReferralSettingsFail(error.response));
    }
};

export const resetReferralSettingsState = () => async (dispatch) => {
    dispatch(resetReferralSettingsStateSuccess());
};

export const {
    doGetReferralSettingsSuccess,
    doGetReferralSettingsFail,
    doUpdateReferralSettingsSuccess,
    doUpdateReferralSettingsFail,
    resetReferralSettingsStateSuccess,
} = referralSettingsSlice.actions;

export const getReferralSettings = (state) => state.referralSettings?.settings;
export const getReferralSettingsSuccess = (state) => state.referralSettings?.success;
export const getReferralSettingsFail = (state) => state.referralSettings?.fail;
export const getReferralSettingsErrorData = (state) => state.referralSettings?.errorDetailData;

export default referralSettingsSlice.reducer;
